import { ButtonBase, SHADOW_LEVEL1, styled } from '@ori-ui/mui';

export const BurgerMenuIconRoot = styled(ButtonBase)<{ ownerState?: { isOpen?: boolean } }>(
  ({ ownerState, theme }) => ({
    color: theme.palette.grey.A700,
    fontSize: theme.typography.pxToRem(28),
    height: 24,
    width: 24,

    [theme.breakpoints.up('md')]: {
      height: 32,
      width: 32,
      '&:hover': {
        '.burgerMenuIconLine': {
          boxShadow: SHADOW_LEVEL1,
        },
      },

      ...(ownerState?.isOpen && {
        '&:hover': {
          '.burgerMenuIconLine': {
            boxShadow: SHADOW_LEVEL1,
          },
        },
      }),
    },
  }),
);

export const BurgerMenuIconWrapper = styled('div')<{
  ownerState?: { isOpen?: boolean; isMobile?: boolean };
}>(({ ownerState, theme }) => ({
  display: 'none',

  ...(ownerState?.isMobile && {
    display: 'block',
  }),

  [theme.breakpoints.up('md')]: {
    display: 'block',

    ...(ownerState?.isMobile && {
      display: 'none',
    }),
  },
}));

export const BurgerMenuIconLine = styled('div')<{
  ownerState?: { isOpen?: boolean; isMobile?: boolean };
}>(({ ownerState, theme }) => ({
  backgroundColor: theme.palette.grey.A700,
  height: 1,
  marginBottom: 6,
  opacity: 1,
  position: 'relative',
  transform: 'translateX(0) rotate(0) translateY(0)',
  transition: 'opacity 0.3s linear, transform 0.3s linear',
  width: 15,

  ...(ownerState?.isMobile && {
    display: 'block',
  }),

  [theme.breakpoints.up('md')]: {
    marginBottom: 8,
    width: 20,
    ...(ownerState?.isOpen && {
      '&:nth-of-type(1)': {
        transform: 'rotate(45deg) translateY(9px) translateX(4px)',
      },

      '&:nth-of-type(2)': {
        opacity: 0,
        transform: 'translateX(22px)',
      },

      '&:nth-of-type(3)': {
        transform: 'rotate(-45deg) translateY(-9px) translateX(4px);',
      },
    }),
  },
  '&:nth-of-type(3)': {
    marginBottom: 0,
  },
}));
